export const DEFAULT_SITE_LANGUAGE = 'en-US';
export const DEFAULT_SITE_MARKET = 'USA';
export const DEFAULT_SITE_CURRENCY = 'USD';
export const ADJUST_APP_LINK = 'https://app.adjust.com/1rjhefg';
export const ADJUST_DEEP_LINK = 'deep_link';
export const ADJUST_REFERRER = 'referrer';
export const ADJUST_PROTOCOL = 'travel-inbound://';
export const ITEM_FEATURES_ICON_SIZE = 16;
export const ITEM_FEATURES_SPACE_BETWEEN = 4;
